import { FlagPennantIcon } from 'components/icons';
import React from 'react';
import { cn } from 'utils';

export function ActivityFlag(props: {
  tag?: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  text: string;
  type: 'default' | 'danger' | 'safe' | 'brand';
}): React.ReactElement {
  const { tag = 'p', text, type } = props;
  const Element = tag;

  return (
    <Element className="odin-flex odin-gap-2 odin-gaElement-2 odin-items-center odin-text-sm">
      <FlagPennantIcon
        className={cn(['odin-size-4'], {
          'odin-text-odin-black': type === 'default',
          'odin-text-odin-primary': type === 'brand',
          'odin-text-odin-danger': type === 'danger',
          'odin-text-odin-success': type === 'safe',
        })}
      />
      <span className="odin-font-bold">{text}</span>
    </Element>
  );
}
